import { autoinject, computedFrom, PLATFORM, useView } from 'aurelia-framework';

import { Version } from '~/api/settings-api';
import { BaseDialog, BaseDialogModel } from '~/components/dialog/base-dialog';
import { DialogUtils } from '~/utils/dialog-utils';

import styles from '~/components/version-number/version-number-dialog/version-number-dialog.module.scss';

export interface VersionNumberDialogModel extends BaseDialogModel {
	backendVersion: Version;
}

@autoinject
@useView(PLATFORM.moduleName('./version-number-dialog.html'))
export class VersionNumberDialog extends BaseDialog<VersionNumberDialogModel> {
	private readonly styles = styles;

	/**
	 * apiDocumentation links to the Swagger documentation, which is built into
	 * the *.jar.
	 */
	private readonly apiDocumentation: string = '/docs/ui/index.html';

	@computedFrom('model.backendVersion.dbSchemaVersion')
	get schemaModifiedPretty(): string {
		if (
			!this.model.backendVersion ||
			!this.model.backendVersion.dbSchemaModified
		) {
			return '';
		}
		return VersionNumberDialog.formatPrettyDate(
			this.model.backendVersion.dbSchemaModified,
		);
	}

	@computedFrom('model.backendVersion.buildDate')
	get buildDatePretty(): string {
		if (
			!this.model.backendVersion ||
			!this.model.backendVersion.buildDate
		) {
			return '';
		}
		return VersionNumberDialog.formatPrettyDate(
			this.model.backendVersion.buildDate,
		);
	}

	private static formatPrettyDate(date: string): string {
		date = date.trim();
		if (!date) {
			return '';
		}
		// NOTE: Jake: 2019-10-28 -  WEBUI-2511
		// Change rendering of date to what Simon requested.
		// - Split date / time
		// - Remove Z from the end
		const dateParts = date.split('T');
		if (dateParts.length === 1) {
			throw new Error('Expected date formatted as UTC but got: ' + date);
		}
		if (dateParts[1].substr(dateParts[1].length - 1) === 'Z') {
			dateParts[1] = dateParts[1].substring(0, dateParts[1].length - 1);
		}
		return dateParts[0] + ' ' + dateParts[1];
	}
}
